import React, { createContext, useContext, useState, useMemo } from 'react';

const ImageContext = createContext();

export function ImageProvider({ children }) {
  const [images, setImages] = useState({});
  const value = useMemo(() => ({ images, setImages }), [images]);
  return <ImageContext.Provider value={value}>{children}</ImageContext.Provider>;
}

export function useImages() {
  const ctx = useContext(ImageContext);
  if (!ctx) throw new Error('useImages must be used within ImageProvider');
  return ctx;
}
